import { useThemeContext } from '#contexts/ThemeContext';
import { Box, Typography } from '@material-ui/core';

export const DetailText = ({ description }: { description: string }) => {
  const { productDescription } = useThemeContext();
  return (
    <Box hidden={!description}>
      {description.split('\n').map((p, key) => (
        <Typography
          key={key}
          paragraph
          variant='subtitle2'
          style={{
            color: productDescription
          }}
        >
          {p}
        </Typography>
      ))}
    </Box>
  );
};
